import { render, staticRenderFns } from "./ReportPageShell.vue?vue&type=template&id=6756f079"
import script from "./ReportPageShell.vue?vue&type=script&lang=js"
export * from "./ReportPageShell.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/_report-enterprise.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports